import "./instrument";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import "./global.css";
import * as Sentry from '@sentry/react';

// if (/Mobi/i.test(window.navigator.userAgent)) {
  const container = document.getElementById("root");
  const root = createRoot(container, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
  });
  
  root.render(
    <HashRouter>
      <App />
    </HashRouter>
  );
// } else {
//   document.getElementById("root").innerHTML = "Please open this page on mobile!"
// }

